var _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHogwartsLetterClosedWithSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 68.887 536.368 419.113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2510_20356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.2344,
    height: 83.6367,
    fill: "white",
    transform: "translate(236 300)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 485.5V247.5H497.5V485.5H66Z",
    fill: "#FBC457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 485.5V247.5M66 485.5H497.5M66 485.5L207.272 356.5M66 247.5H497.5M66 247.5L207.272 356.5M497.5 247.5V485.5M497.5 247.5L354.582 356.5M497.5 485.5L354.582 356.5M354.582 356.5L280.5 413L207.272 356.5",
    stroke: "white",
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2510_20356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.781 309.884L281.665 311.347L282.507 309.859L282.51 309.855C282.701 309.517 284.265 306.755 288.053 304.403C291.841 302.052 297.941 300.057 307.303 301.43C317.464 302.936 323.916 310.297 325.706 320.051C327.501 329.835 324.583 342.023 315.853 352.876L315.852 352.877C298.221 374.863 284.142 381.469 281.592 382.551C279.03 381.444 264.923 374.779 247.323 352.876L247.322 352.876C238.593 342.023 235.686 329.836 237.5 320.053C239.307 310.299 245.783 302.937 255.971 301.43C265.332 300.057 271.432 302.064 275.22 304.421C278.892 306.706 280.476 309.371 280.756 309.842C280.766 309.859 280.774 309.873 280.781 309.884Z",
    fill: "white",
    stroke: "#FFC629",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.642 358.978C275.834 358.978 265.41 357.302 260.744 352.173C257.667 348.82 255.135 343.642 266.552 346.502C266.552 346.502 266.651 344.135 266.899 343.987C266.651 336.442 266.155 328.256 264.815 320.464C264.765 320.02 265.013 319.774 266.055 319.675C276.38 318.541 286.804 318.541 297.178 319.675C298.171 319.774 298.469 320.02 298.419 320.464C297.079 328.256 296.583 336.442 296.335 343.987C296.583 344.184 296.682 346.502 296.682 346.502C308.099 343.642 305.567 348.82 302.539 352.173C297.873 357.351 287.449 358.978 281.642 358.978Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.894 343.988C276.574 346.306 286.65 346.306 296.379 343.988C296.379 343.988 296.727 343.988 296.727 344.876V349.117C296.727 349.117 292.607 351.583 281.637 351.583C270.667 351.583 266.547 349.068 266.547 349.068V344.728C266.547 344.728 266.547 344.038 266.894 343.988Z",
    fill: "#FFC629"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M158.791 220.448L172.7 230.776L189.552 234.792L179.224 248.701L175.208 265.553L161.299 255.225L144.447 251.209L154.775 237.3L158.791 220.448Z",
    fill: "#2B2B2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M421.087 158.919L423.311 180.507L438.42 196.088L416.831 198.312L401.25 213.421L399.026 191.832L383.917 176.251L405.506 174.027L421.087 158.919Z",
    fill: "#2B2B2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M345.253 440.42L343.029 418.831L327.92 403.251L349.509 401.026L365.09 385.918L367.314 407.507L382.422 423.088L360.834 425.312L345.253 440.42Z",
    fill: "#2B2B2B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M360.414 190.788L368.527 196.813L378.357 199.155L372.333 207.269L369.99 217.099L361.877 211.074L352.046 208.732L358.071 200.618L360.414 190.788Z",
    fill: "#2B2B2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M405.926 408.551L397.813 402.526L387.982 400.184L394.007 392.07L396.35 382.24L404.463 388.264L414.294 390.607L408.269 398.72L405.926 408.551Z",
    fill: "#2B2B2B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184.945 189.944L190.509 198.381L198.945 203.944L190.509 209.508L184.945 217.944L179.382 209.508L170.945 203.944L179.382 198.381L184.945 189.944Z",
    fill: "#2B2B2B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1014 253.539L86.5628 263.634L90.9629 272.732L80.8676 273.193L71.77 277.593L71.3086 267.498L66.9085 258.4L77.0038 257.939L86.1014 253.539Z",
    fill: "#2B2B2B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145 157L148.577 162.423L154 166L148.577 169.577L145 175L141.423 169.577L136 166L141.423 162.423L145 157Z",
    fill: "#2B2B2B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9466 222.607L36.2432 229.096L39.0718 234.945L32.582 235.241L26.7336 238.07L26.4369 231.58L23.6083 225.732L30.0981 225.435L35.9466 222.607Z",
    fill: "#2B2B2B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M442 281L445.577 286.423L451 290L445.577 293.577L442 299L438.423 293.577L433 290L438.423 286.423L442 281Z",
    fill: "#2B2B2B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M521 223L524.577 228.423L530 232L524.577 235.577L521 241L517.423 235.577L512 232L517.423 228.423L521 223Z",
    fill: "#2B2B2B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M504 205L505.987 208.013L509 210L505.987 211.987L504 215L502.013 211.987L499 210L502.013 208.013L504 205Z",
    fill: "#2B2B2B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M244 421L245.987 424.013L249 426L245.987 427.987L244 431L242.013 427.987L239 426L242.013 424.013L244 421Z",
    fill: "#2B2B2B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M70 223L71.987 226.013L75 228L71.987 229.987L70 233L68.013 229.987L65 228L68.013 226.013L70 223Z",
    fill: "#2B2B2B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M381.947 87.6065L382.243 94.0963L385.072 99.9448L378.582 100.241L372.734 103.07L372.437 96.5802L369.608 90.7318L376.098 90.4351L381.947 87.6065Z",
    fill: "#2B2B2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHogwartsLetterClosedWithSparkles);
export default __webpack_public_path__ + "static/media/hogwarts-letter-closed-with-sparkles.ccdaf073ddf44e6d3b36ffb4bf29c296.svg";
export { ForwardRef as ReactComponent };